import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon } from 'lucide-react';
const HeaderCPAP7Tips = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-3347">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-3348"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-3349">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-3350">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-3351">
            MEDPRESS GAZETTE
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-3352">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-3353">
          <div className="text-left" data-id="element-3354">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-3355">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-3356">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-3357">
        <div className="max-w-4xl mx-auto" data-id="element-3358">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-3359">
            PERSONAL REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-2" data-id="element-3360">
            7 Things I Wish Someone Told Me Before Starting CPAP Therapy
          </h1>
          <p className="text-base sm:text-lg text-gray-600 italic mb-5" data-id="element-3361">
            (From a Retired Internal Medicine Physician Who Spent Over 9 Years
            Fighting His Machine—And Finally Won)
          </p>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-3362">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-3363">
              <img src="https://cdn.magicpatterns.com/uploads/7shb5opeS59WKfMtsQV6ZV/photo_2026-02-03_17.01.34.jpg" alt="Dr. Robert Harriman" className="w-full h-full object-cover" data-id="element-3364" />
            </div>
            <div className="flex-1" data-id="element-3365">
              <div className="flex items-center" data-id="element-3366">
                <div className="font-medium text-gray-900 text-lg" data-id="element-3367">
                  By Dr. Robert Harriman, MD, FACP
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-3368">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-3369" />
                  <span className="text-xs ml-1 font-medium" data-id="element-3370">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-3371">
                Cleveland, OH • Retired Internal Medicine Physician • 67 Years
                Old • 18 Years on CPAP Therapy
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-3372">
                <div className="flex items-center mr-4" data-id="element-3373">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-3374" />
                  <span data-id="element-3375">18 min read</span>
                </div>
                <div className="flex items-center" data-id="element-3376">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-3377" />
                  <span data-id="element-3378">42,372 views</span>
                </div>
              </div>
            </div>
          </div>

          <div className="my-4" data-id="element-3379"></div>

          <img src="https://cdn.magicpatterns.com/uploads/oqTETe7EFDL1TGccUKKinw/CPAP_Struggle_all_you_need_to_know.png" alt="CPAP Struggle: All You Need To Know" className="w-full rounded-lg shadow-md my-4" data-id="element-3380" />

          <div className="my-4 border-l-4 border-gray-800 pl-6 py-4 bg-gradient-to-r from-gray-100 to-white shadow-sm" data-id="element-3381">
            <p className="text-sm uppercase tracking-wide text-gray-500 mb-2 font-semibold" data-id="element-3382">
              ARTICLE SUMMARY
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic" data-id="element-3383">
              "What a Cleveland Clinic physician discovered after 18 years of
              total CPAP therapy:
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-3384">
              7 insider strategies that address the air belly, panic attacks,
              dry mouth, ear pressure, nose sores, rainout, and the devastating
              'I can't sleep on my side' problem that was silently destroying
              his treatment effectiveness...
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-3385">
              — now sharing his first blog post after 38 years of medical
              practice."
            </p>
          </div>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-3386">
            <div className="mb-1 flex items-center" data-id="element-3387">
              <span className="font-medium mr-2" data-id="element-3388">Published by:</span>
              MedPress Gazette Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-3389">
              <span className="font-medium mr-2" data-id="element-3390">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderCPAP7Tips;